import React, {useEffect, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import {ToggleButton} from "./ToggleButton";
import {Card, CardContent, Stack} from "@mui/material";
import {
    AdaptRecordingMode,
    GridVideoLayout,
    HighVideoResolution, LibrettoPlan, LibrettoRecordingMode,
    SingleSpeakerVideoLayout,
    SpeakerVideoLayout,
    StandardVideoResolution
} from "../../utils/utils";
import TranscriptionLanguageSelectDropdown from "../Studio/TranscriptionLanguageDropdown";
import NewTranscriptionLangDropdown, {
    NameStyleSelect,
    NewTranscriptionLangDropDown,
    StudioThemeSelectDropdown
} from "./NewTranscriptionLangDropdown";
import RecordingModeToggle from "./RecordingModeToggle";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "../../Firebase";
import {kRoomStateCollectionName} from "../../utils/CollectionConstants";
import BrandLogos from "./BrandLogos";
import Tooltip from "@mui/material/Tooltip";
import {useNavigate} from "react-router-dom";

const GeneralIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M16.4893 7.19032C16.2814 6.70893 15.7082 6.34355 15.2136 6.37822C14.719 6.41289 14.1472 6.21954 13.8939 5.97817C13.6406 5.73681 13.4353 5.16608 13.454 4.66869C13.4727 4.1713 13.0901 3.6139 12.6008 3.41921C12.1116 3.22452 11.4504 3.37254 11.1252 3.74458C10.7999 4.11662 10.2547 4.38999 9.90811 4.40066C9.56152 4.41132 9.00964 4.15129 8.67371 3.78858C8.33779 3.42587 7.66994 3.29653 7.18871 3.50455C6.70748 3.71257 6.33956 4.28598 6.37422 4.7807C6.40888 5.27543 6.21559 5.84749 5.97431 6.10086C5.73303 6.35422 5.16249 6.55691 4.66793 6.54091C4.17337 6.52491 3.6135 6.90628 3.41887 7.39567C3.22425 7.88506 3.37222 8.54648 3.74413 8.87185C4.11605 9.19722 4.38933 9.74262 4.39999 10.088C4.41065 10.4334 4.15204 10.9868 3.78812 11.3228C3.42421 11.6588 3.29357 12.3256 3.50419 12.8096C3.71481 13.2937 4.28535 13.6591 4.77991 13.6244C5.27446 13.5897 5.84634 13.7831 6.09962 14.0245C6.35289 14.2658 6.55818 14.8339 6.53952 15.3313C6.52086 15.8287 6.90344 16.3861 7.394 16.5808C7.88455 16.7754 8.54441 16.6274 8.86967 16.2554C9.19493 15.8833 9.73881 15.61 10.0854 15.6046C10.432 15.5993 10.9839 15.8567 11.3225 16.2194C11.6611 16.5821 12.3276 16.7061 12.8088 16.4981C13.29 16.2901 13.6579 15.7193 13.6233 15.2246C13.5886 14.7299 13.7819 14.1578 14.0232 13.9044C14.2645 13.6511 14.8337 13.4484 15.3309 13.4684C15.8281 13.4884 16.3853 13.1043 16.58 12.6136C16.7746 12.1229 16.6293 11.4628 16.2547 11.1348C15.8801 10.8067 15.6069 10.268 15.5975 9.9173C15.5882 9.5666 15.8468 9.01853 16.2121 8.68249C16.3941 8.48514 16.5167 8.24038 16.5657 7.97639C16.6148 7.7124 16.5883 7.43991 16.4893 7.19032V7.19032ZM11.0239 12.3829C10.5528 12.5867 10.0319 12.646 9.52707 12.5536C9.02225 12.4611 8.5562 12.2209 8.18789 11.8633C7.81957 11.5058 7.56555 11.0471 7.45795 10.5451C7.35036 10.0431 7.39403 9.52046 7.58344 9.04332C7.77286 8.56617 8.0995 8.15595 8.52204 7.86456C8.94458 7.57317 9.44402 7.4137 9.95719 7.40634C10.4704 7.39898 10.9742 7.54404 11.4049 7.82319C11.8356 8.10233 12.1739 8.50301 12.3769 8.97453C12.6491 9.60555 12.6599 10.3188 12.407 10.9578C12.154 11.5968 11.6581 12.1093 11.0279 12.3829H11.0239Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

const DesignIcon = ({isSelected}) => {

    const fillColor = isSelected ? "#2B6BFD" : "#1A1A1A";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.0003 1.66663C14.602 1.66663 18.3337 4.98163 18.3337 9.07413C18.333 10.3018 17.845 11.479 16.9768 12.347C16.1086 13.215 14.9313 13.7029 13.7037 13.7033H12.0653C11.297 13.7033 10.6762 14.3241 10.6762 15.0925C10.6762 15.4441 10.8153 15.7683 11.0278 16.0091C11.2503 16.2591 11.3895 16.5833 11.3895 16.9441C11.3895 17.7133 10.7503 18.3333 10.0003 18.3333C5.39866 18.3333 1.66699 14.6016 1.66699 9.99996C1.66699 5.39829 5.39866 1.66663 10.0003 1.66663ZM9.00949 15.0925C9.00916 14.6911 9.08798 14.2936 9.24143 13.9227C9.39489 13.5518 9.61997 13.2148 9.90379 12.9309C10.1876 12.6471 10.5246 12.422 10.8955 12.2686C11.2664 12.1151 11.6639 12.0363 12.0653 12.0366H13.7037C14.4892 12.0362 15.2424 11.7241 15.798 11.1688C16.3536 10.6135 16.6661 9.86046 16.667 9.07496C16.667 5.94913 13.7237 3.33329 10.0003 3.33329C8.27997 3.33172 6.62561 3.99526 5.38314 5.18517C4.14067 6.37508 3.40629 7.99923 3.33354 9.71805C3.26079 11.4369 3.85531 13.1173 4.9928 14.4079C6.13028 15.6985 7.72266 16.4995 9.43699 16.6433C9.15796 16.1744 9.0103 15.639 9.00949 15.0933V15.0925ZM6.25033 9.99996C5.9188 9.99996 5.60086 9.86826 5.36644 9.63384C5.13202 9.39942 5.00033 9.08148 5.00033 8.74996C5.00033 8.41844 5.13202 8.1005 5.36644 7.86608C5.60086 7.63166 5.9188 7.49996 6.25033 7.49996C6.58185 7.49996 6.89979 7.63166 7.13421 7.86608C7.36863 8.1005 7.50033 8.41844 7.50033 8.74996C7.50033 9.08148 7.36863 9.39942 7.13421 9.63384C6.89979 9.86826 6.58185 9.99996 6.25033 9.99996V9.99996ZM13.7503 9.99996C13.4188 9.99996 13.1009 9.86826 12.8664 9.63384C12.632 9.39942 12.5003 9.08148 12.5003 8.74996C12.5003 8.41844 12.632 8.1005 12.8664 7.86608C13.1009 7.63166 13.4188 7.49996 13.7503 7.49996C14.0818 7.49996 14.3998 7.63166 14.6342 7.86608C14.8686 8.1005 15.0003 8.41844 15.0003 8.74996C15.0003 9.08148 14.8686 9.39942 14.6342 9.63384C14.3998 9.86826 14.0818 9.99996 13.7503 9.99996ZM10.0003 7.49996C9.6688 7.49996 9.35086 7.36826 9.11644 7.13384C8.88202 6.89942 8.75033 6.58148 8.75033 6.24996C8.75033 5.91844 8.88202 5.6005 9.11644 5.36608C9.35086 5.13166 9.6688 4.99996 10.0003 4.99996C10.3318 4.99996 10.6498 5.13166 10.8842 5.36608C11.1186 5.6005 11.2503 5.91844 11.2503 6.24996C11.2503 6.58148 11.1186 6.89942 10.8842 7.13384C10.6498 7.36826 10.3318 7.49996 10.0003 7.49996Z"
                fill={fillColor}/>
        </svg>
    )
}

const RecordingIcon = ({isSelected}) => {

    const fillColor = isSelected ? "#2B6BFD" : "#1A1A1A";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.0003 18.3333C5.39783 18.3333 1.66699 14.6025 1.66699 9.99996C1.66699 5.39746 5.39783 1.66663 10.0003 1.66663C14.6028 1.66663 18.3337 5.39746 18.3337 9.99996C18.3337 14.6025 14.6028 18.3333 10.0003 18.3333ZM10.0003 16.6666C11.7684 16.6666 13.4641 15.9642 14.7144 14.714C15.9646 13.4638 16.667 11.7681 16.667 9.99996C16.667 8.23185 15.9646 6.53616 14.7144 5.28591C13.4641 4.03567 11.7684 3.33329 10.0003 3.33329C8.23222 3.33329 6.53652 4.03567 5.28628 5.28591C4.03604 6.53616 3.33366 8.23185 3.33366 9.99996C3.33366 11.7681 4.03604 13.4638 5.28628 14.714C6.53652 15.9642 8.23222 16.6666 10.0003 16.6666V16.6666ZM10.0003 12.5C9.33728 12.5 8.7014 12.2366 8.23256 11.7677C7.76372 11.2989 7.50033 10.663 7.50033 9.99996C7.50033 9.33692 7.76372 8.70103 8.23256 8.23219C8.7014 7.76335 9.33728 7.49996 10.0003 7.49996C10.6634 7.49996 11.2993 7.76335 11.7681 8.23219C12.2369 8.70103 12.5003 9.33692 12.5003 9.99996C12.5003 10.663 12.2369 11.2989 11.7681 11.7677C11.2993 12.2366 10.6634 12.5 10.0003 12.5Z"
                fill={fillColor}/>
        </svg>
    )
}

const VideoLayoutSelectCard = ({selectedVideoLayout, updateVideoLayout}) => {

    const headerTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        fontStyle: "normal",
        color: "#1a1a1a",
        marginBottom: "12px",
    }

    const innerTextStyle = {
        ...headerTextStyle,
        opacity: 0.5,
        marginBottom: 0,
    }

    return (
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" marginBottom={0}>
            <Box
                onClick={() => updateVideoLayout({videoLayout: GridVideoLayout})}
                style={{
                    cursor: 'pointer',
                    position: 'relative',
                    border: selectedVideoLayout === GridVideoLayout ? `1.5px solid #2B6BFD` : '1px solid #E8E8E8',
                    padding: "20px",
                    flexDirection: "column",
                    gap: "12px",
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    height: "112px",
                    width: "190px",
                    borderRadius: '8px',
                    backgroundColor: selectedVideoLayout === GridVideoLayout ? '#eff4fe' : 'white',
                }}
            >
                <div style={headerTextStyle}>
                    Grid
                </div>
                <div style={innerTextStyle}>
                    Every participant's video is in a grid.
                </div>
            </Box>
            <Box
                onClick={() => updateVideoLayout({videoLayout: SpeakerVideoLayout})}
                style={{
                    cursor: 'pointer',
                    position: 'relative',
                    border: selectedVideoLayout === SpeakerVideoLayout ? `1.5px solid #2B6BFD` : '1px solid #E8E8E8',
                    padding: "20px",
                    flexDirection: "column",
                    gap: "12px",
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    height: "112px",
                    width: "190px",
                    borderRadius: '8px',
                    backgroundColor: selectedVideoLayout === SpeakerVideoLayout ? '#eff4fe' : 'white',
                }}
            >
                <div style={headerTextStyle}>
                    Speaker
                </div>
                <div style={innerTextStyle}>
                    The active speaker is centered.
                </div>
            </Box>
            <Box
                onClick={() => updateVideoLayout({videoLayout: SingleSpeakerVideoLayout})}
                style={{
                    cursor: 'pointer',
                    position: 'relative',
                    border: selectedVideoLayout === SingleSpeakerVideoLayout ? `1.5px solid #2B6BFD` : '1px solid #E8E8E8',
                    padding: "20px",
                    flexDirection: "column",
                    gap: "12px",
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    height: "112px",
                    width: "190px",
                    borderRadius: '8px',
                    backgroundColor: selectedVideoLayout === SingleSpeakerVideoLayout ? '#eff4fe' : 'white',
                }}
            >
                <div style={headerTextStyle}>
                    Single Speaker
                </div>
                <div style={innerTextStyle}>
                    The active speaker takes the full screen.
                </div>
            </Box>
        </Stack>
    )
}

const VideoQualitySelectCard = ({selectedVideoQuality, updateVideoResolution, isRestrictedPlan}) => {

    const updateToHighVideoResolution = () => {
        if (isRestrictedPlan) {
            return;
        }
        updateVideoResolution({videoResolution: HighVideoResolution})
    }

    return (
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" marginBottom={0}>
            <Box
                onClick={() => updateVideoResolution({videoResolution: StandardVideoResolution})}
                style={{
                    cursor: 'pointer',
                    position: 'relative',
                    border: selectedVideoQuality === StandardVideoResolution ? `1.5px solid #2B6BFD` : '1px solid #E8E8E8',
                    // overflow: 'visible',
                    height: "160px",
                    width: "290px",
                    borderRadius: '8px',
                    padding: "20px",
                    flexDirection: "column",
                }}
            >
                <div style={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#1a1a1a",
                    marginBottom: "12px"
                }}>
                    Standard Resolution
                </div>
                <div style={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#999",
                    marginBottom: "12px"
                }}>
                    Separate tracks record in 720p. You can export composed edits in higher resolutions up to 4K.
                </div>
                <div style={{fontFamily: "Inter", fontSize: "12px", fontWeight: 500, color: "#999"}}>
                    Fast upload and processing times.
                </div>
            </Box>
            <Tooltip title={isRestrictedPlan ? "Unlock on Standard Plan" : ""}>
                <Box
                    onClick={updateToHighVideoResolution}
                    style={{
                        cursor: isRestrictedPlan ? 'not-allowed' : 'pointer',
                        position: 'relative',
                        border: selectedVideoQuality === HighVideoResolution ? `1.5px solid #2B6BFD` : '1px solid #E8E8E8',
                        // overflow: 'visible',
                        height: "160px",
                        width: "290px",
                        borderRadius: '8px',
                        padding: "20px",
                        flexDirection: "column",
                    }}
                >
                    <div style={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#1a1a1a",
                        marginBottom: "12px"
                    }}>
                        High Resolution
                    </div>
                    <div style={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#999",
                        marginBottom: "32px"
                    }}>
                        For cameras that support 1080p and 4K HD recording.
                    </div>
                    <div style={{fontFamily: "Inter", fontSize: "12px", fontWeight: 500, color: "#999"}}>
                        Longer upload and processing times.
                    </div>
                </Box>
            </Tooltip>
        </Stack>
    )
}

const SettingsMenu = React.memo(({
                                     onClose,
                                     projectId,
                                     noiseCancellationEnabled,
                                     localRecordingEnabled,
                                     videoMirrored,
                                     selectedVideoLayout,
                                     studioTheme,
                                     studioNameStyle,
                                     selectedLanguage,
                                     selectedVideoResolution,
                                     recordingMode,
                                     roomName,
                                     userPlan,
                                     selectedBrandLogo
                                 }) => {

    const [selectedMenuItemIndex, setSelectedMenuItemIndex] = useState(0);

    const scrollRef = useRef(null);
    const scrollPositionRef = useRef(0);

    const designScrollRef = useRef(null);
    const designScrollPositionRef = useRef(0);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (scrollContainer) {
            scrollContainer.scrollTop = scrollPositionRef.current;
        }
    });

    useEffect(() => {
        const scrollContainer = designScrollRef.current;
        if (scrollContainer) {
            scrollContainer.scrollTop = designScrollPositionRef.current;
        }
    });

    const handleScroll = () => {
        scrollPositionRef.current = scrollRef.current.scrollTop;
    };

    const handleDesignScroll = () => {
        designScrollPositionRef.current = designScrollRef.current.scrollTop;
    };

    const menuItems = [
        {icon: <RecordingIcon isSelected={selectedMenuItemIndex === 0}/>, label: 'Recording'},
        {icon: <DesignIcon isSelected={selectedMenuItemIndex === 1}/>, label: 'Design'},
    ];

    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        height: "750px",
        overflow: "hidden",
    }

    const sideBarStyle = {
        width: "233px",
        display: "flex",
        height: "750px",
        padding: "28px 12px 12px 12px",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        alignSelf: "stretch",
        borderRight: "1px solid #E8E8E8",
    }

    const sideBarItemStyle = {
        display: 'flex',
        flexDirection: 'row',
        padding: "16px 12px",
        alignItems: 'center',
        gap: "12px",
        alignSelf: "stretch",
        borderRadius: "8px",
        cursor: 'pointer',
        backgroundColor: "transparent",
        '&:hover': {
            backgroundColor: '#e5e5e5', // Darker primary color
        },
    }

    const selectedSideBarItemStyle = {
        ...sideBarItemStyle,
        backgroundColor: "#eff4fe",
        '&:hover': {
            backgroundColor: '#ffffff', // Darker primary color
        },
    }

    const effectiveItemStyle = (index) => {
        return index === selectedMenuItemIndex ? selectedSideBarItemStyle : sideBarItemStyle;
    }

    const sideBarItemTextStyle = {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "20px",
        letterSpacing: "0.16px",
    }

    const selectedSideBarItemTextStyle = {
        ...sideBarItemTextStyle,
        color: "#2B6BFD",
    }

    const effectiveItemTextStyle = (index) => {
        return index === selectedMenuItemIndex ? selectedSideBarItemTextStyle : sideBarItemTextStyle;
    }

    const sideBarIconStyle = {
        display: "flex",
        width: "20px",
        height: "20px",
        justifyContent: "center",
        alignItems: "center",
    }

    const selectedSideBarIconStyle = {
        ...sideBarIconStyle,
        color: "#2B6BFD",
    }

    const effectiveIconStyle = (index) => {
        return index === selectedMenuItemIndex ? selectedSideBarIconStyle : sideBarIconStyle;
    }

    const settingsTextStyle = {
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "0.48px",
        color: "#999999",
    }

    const settingsTextBoxStyle = {
        display: "flex",
        padding: "0px 12px",
        marginTop: "auto",
        alignItems: "center",
        gap: "10px",
        alignSelf: "stretch",
    }

    const mainContentStyle = {
        display: 'flex',
        width: "640px",
        height: "750px",
        padding: "40px 24px 40px 24px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "32px",
        justifyContent: "space-between",
        overflowY: "auto",
        overflowX: "hidden", // Add this line to hide horizontal scrollbar
        boxSizing: "border-box",
    }

    const designContentStyle = {
        display: 'flex',
        width: "640px",
        height: "750px",
        padding: "40px 24px 40px 24px",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        overflowX: "hidden", // Add this line to hide horizontal scrollbar
        gap: "32px",
        overflowY: "auto",
    }

    const topTitleStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
    }

    const titleTextStyle = {
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "24px",
        letterSpacing: "0.18px",
    }

    const audioRecordingSettingsStyle = {
        display: "flex",
        alignItems: "flex-start",
        gap: "16px",
        alignSelf: "stretch",
        flexDirection: "column",
    }

    const themeStyle = {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        flexShrink: 0,
    }

    const audioRSTitleStyle = {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "20px",
        letterSpacing: "0.16px",
    }

    const audioDescTextStyle = {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "20px",
        letterSpacing: "0.14px",
        wordWrap: 'break-word',
        color: '#999999',
    }

    const audioDescHeaderStyle = {
        ...audioDescTextStyle,
        marginBottom: "8px",
        color: '#1A1A1A',
    }

    const Divider = () => {
        return (
            <Box style={{
                width: '100%',
                // height: '100%',
                paddingTop: 1,
                paddingBottom: 1,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 10,
            }}>
                <div style={{alignSelf: 'stretch', height: 1, background: '#E8E8E8'}}/>
            </Box>
        )
    }

    const RecordingMenu = ({roomName, userPlan, recordingMode}) => {

        const navigate = useNavigate();

        const updateNoiseCancellation = async ({enabled}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {backgroundNoiseCancellationEnabled: enabled});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateLocalRecording = async ({enabled}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {localRecordingEnabled: enabled});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateVideoMirroring = async ({enabled}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {videoMirrored: enabled});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateVideoResolution = async ({videoResolution}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {videoRecordingQuality: videoResolution});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateVideoLayout = async ({videoLayout}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {videoRecordingLayout: videoLayout});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateTranscriptionLanguage = async (transcriptionLanguage) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {transcriptionLanguage: transcriptionLanguage});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const isVideoRecordingDisabled = userPlan === LibrettoPlan.AppSumoTier1;

        const isLocalRecordingDisabled = userPlan === LibrettoPlan.Free;

        const localRecordingText = "In addition to cloud recording, records media at high-quality on participant's device " +
            "and uploads to Libretto.";

        const isHighVideoResolutionRecordingDisabled = userPlan === LibrettoPlan.Free;

        const readableRecordingMode = recordingMode === LibrettoRecordingMode.Audio ? 'Audio only' : 'Video & audio';

        const navigateToUpgrade = () => {
            navigate("/settings?upgrade=true")
        }

        return (
            <Box sx={mainContentStyle} ref={scrollRef} onScroll={handleScroll}>
                <Box sx={topTitleStyle}>
                    <Typography style={titleTextStyle}>Recording Settings</Typography>
                    <CloseIcon onClick={onClose} sx={{cursor: 'pointer'}}/>
                </Box>
                <Divider/>
                <Box sx={{audioRecordingSettingsStyle}}>
                    <Box sx={{flexDirection: "row", display: "flex", width: "100%", justifyContent: "space-between"}}>
                        <Box sx={audioRSTitleStyle}>
                            Recording mode
                        </Box>
                        <Box sx={audioRSTitleStyle}>
                            {readableRecordingMode}
                        </Box>
                    </Box>
                    <div style={{height: "16px"}}></div>
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        width: "100%",
                        height: "50px",
                        justifyContent: "space-between"
                    }}>
                        <Box sx={{width: "60%"}}>
                            {!isVideoRecordingDisabled ? <Typography style={audioDescTextStyle}>
                                    Choose what you want to record. You’ll always be able to see each other while recording.
                                </Typography> :
                                <Typography style={audioDescTextStyle}>Your plan supports audio-only recording. Upgrade
                                    your plan to enable video recording.</Typography>}
                        </Box>
                        <Box>
                            <RecordingModeToggle roomName={roomName} userPlan={userPlan} recordingMode={recordingMode}/>
                        </Box>
                    </Box>
                    <div style={{height: "16px"}}></div>
                    <Box sx={{flexDirection: "row", display: "flex", width: "100%", justifyContent: "space-between"}}>
                        <Box sx={audioRSTitleStyle}>
                            On-Device Recording
                        </Box>
                        <Box>
                            <ToggleButton checked={localRecordingEnabled} disabled={isLocalRecordingDisabled}
                                          onChange={(e) => updateLocalRecording({enabled: !localRecordingEnabled})}/>
                        </Box>
                    </Box>
                    <div style={{height: "16px"}}></div>
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        width: "100%",
                        height: "50px",
                        justifyContent: "space-between"
                    }}>
                        <Box sx={{width: "80%"}}>
                            <Typography style={audioDescTextStyle}>
                                {localRecordingText}{' '}
                                <span onClick={navigateToUpgrade}>
                                    {isLocalRecordingDisabled && <Typography style={{
                                        color: "#2B6BFD", fontFamily: "Inter",
                                        fontSize: "14px", cursor: "pointer"
                                    }}>
                                        Upgrade to unlock.
                                    </Typography>}
                                </span>
                            </Typography>
                        </Box>
                        <Box sx={audioRSTitleStyle}>
                            {localRecordingEnabled ? "Enabled" : "Disabled"}
                        </Box>
                    </Box>
                </Box>
                <Divider/>
                <Box sx={{audioRecordingSettingsStyle}}>
                    <Box sx={audioRSTitleStyle}>
                        Audio
                    </Box>
                    <div style={{height: "16px"}}></div>
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        width: "100%",
                        height: "68px",
                        justifyContent: "space-between"
                    }}>
                        <Box sx={{width: "85%"}}>
                            <Typography style={audioDescHeaderStyle}>Background Noise Cancellation</Typography>
                            <Typography style={audioDescTextStyle}>
                                Reduce background noise like air conditioners and laptop fans for all participants. This
                                usually ensures the best audio quality.
                            </Typography>
                        </Box>
                        <Box>
                            <ToggleButton checked={noiseCancellationEnabled}
                                          onChange={(e) => updateNoiseCancellation({enabled: !noiseCancellationEnabled})}/>
                        </Box>
                    </Box>
                </Box>
                <Divider/>
                <Box sx={audioRecordingSettingsStyle}>
                    <Box sx={audioRSTitleStyle}>
                        Video
                    </Box>
                    <VideoQualitySelectCard selectedVideoQuality={selectedVideoResolution}
                                            updateVideoResolution={updateVideoResolution} isRestrictedPlan={isHighVideoResolutionRecordingDisabled}/>
                </Box>
                <Divider/>
                <Box sx={audioRecordingSettingsStyle}>
                    <Box sx={audioRSTitleStyle}>
                        Video Recording Layout
                    </Box>
                    <div style={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#999",
                        marginTop: "-5px"
                    }}>
                        Select how participants will be arranged in the final composite video recording.
                    </div>
                    <VideoLayoutSelectCard selectedVideoLayout={selectedVideoLayout}
                                           updateVideoLayout={updateVideoLayout}/>
                </Box>
                <Box sx={{flexDirection: "row", display: "flex", width: "100%", justifyContent: "space-between"}}>
                    <Box sx={audioRSTitleStyle}>
                        Mirror video
                        <Typography style={{...audioDescTextStyle, marginTop: "10px"}}>This does not affect the recorded
                            video.</Typography>
                    </Box>
                    <Box>
                        <ToggleButton checked={videoMirrored}
                                      onChange={(e) => updateVideoMirroring({enabled: !videoMirrored})}/>
                    </Box>
                </Box>
                <Divider/>
                <Box sx={audioRecordingSettingsStyle} height="100px">
                    <Box sx={audioRSTitleStyle}>
                        Transcription Language
                    </Box>
                    <Box style={{
                        flexDirection: "row",
                        display: "flex",
                        width: "592px",
                        gap: "32px",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <div style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#999999",
                            marginBottom: "12px",
                        }}>
                            Set the language being spoken in the studio. You can change it at any time.
                        </div>
                        <div style={{paddingBottom: "10px"}}>
                            <NewTranscriptionLangDropdown selectedLanguage={selectedLanguage}
                                                          onChange={updateTranscriptionLanguage}/>
                        </div>
                    </Box>
                </Box>
            </Box>
        )
    }

    const DesignMenu = ({roomName, studioTheme, studioNameStyle, selectedBrandLogo}) => {

        const updateStudioTheme = async ({studioTheme}) => {

            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {studioTheme: studioTheme});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateStudioNameStyle = async ({studioNameStyle}) => {

            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {studioNameStyle: studioNameStyle});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        const updateStudioBrandLogo = async ({assetId, url}) => {
            if (roomName === '') {
                return;
            }

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {studioBrandLogo: {assetId: assetId, url: url}});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        return (
            <Box sx={designContentStyle} onScroll={handleDesignScroll} ref={designScrollRef}>
                <Box sx={topTitleStyle}>
                    <Typography style={titleTextStyle}>Design</Typography>
                    <CloseIcon onClick={onClose} sx={{cursor: 'pointer'}}/>
                </Box>
                <Divider/>
                <Box sx={themeStyle}>
                    <Box sx={audioRSTitleStyle}>
                        Logo
                    </Box>
                    <div style={{height: "0px"}}></div>
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        width: "592px",
                        height: "68px",
                        justifyContent: "flex-start",
                    }}>
                        <BrandLogos projectId={projectId} selectedBrandLogo={selectedBrandLogo}
                                    updateStudioBrandLogo={updateStudioBrandLogo}/>
                    </Box>
                </Box>
                <Divider/>
                <Box sx={themeStyle}>
                    <Box sx={audioRSTitleStyle}>
                        Theme
                    </Box>
                    {/*<div style={{height: "3px"}}></div>*/}
                    <Box sx={{
                        flexDirection: "row",
                        display: "flex",
                        width: "592px",
                        height: "68px",
                        justifyContent: "flex-start",
                    }}>
                        <StudioThemeSelectDropdown selectedTheme={studioTheme} updateStudioTheme={updateStudioTheme}/>
                    </Box>
                </Box>
                <Divider/>
                <Box sx={themeStyle}>
                    <Box sx={audioRSTitleStyle}>
                        Name Style
                    </Box>
                    <NameStyleSelect selectedStyle={studioNameStyle} updateStudioNameStyle={updateStudioNameStyle}/>
                </Box>
            </Box>
        )
    }


    return (
        <Box sx={mainStyle}>
            {/* Left sidebar */}
            <Box sx={sideBarStyle}>
                <Box style={{width: "100%"}}>
                    {menuItems.map((item, index) => (
                        <Box key={index} sx={effectiveItemStyle(index)} onClick={() => setSelectedMenuItemIndex(index)}>
                            <Box sx={effectiveIconStyle(index)}>{item.icon}</Box>
                            <Typography sx={effectiveItemTextStyle(index)}>{item.label}</Typography>
                        </Box>
                    ))}
                </Box>
                {selectedMenuItemIndex === 0 && <Box style={settingsTextStyle} marginTop={"10px"}>
                    Tip: Press Ctrl + F enable full screen mode for the recording area, and press ESC to exit full
                    screen mode.
                </Box>}
                <Box style={settingsTextBoxStyle}>
                    <Typography sx={settingsTextStyle}>
                        Settings are saved automatically
                    </Typography>
                </Box>
            </Box>

            {/* Main content */}
            {selectedMenuItemIndex === 0 ?
                <RecordingMenu userPlan={userPlan} roomName={roomName} recordingMode={recordingMode}/> :
                <DesignMenu roomName={roomName} studioTheme={studioTheme} studioNameStyle={studioNameStyle}
                            selectedBrandLogo={selectedBrandLogo}/>}
        </Box>
    );
});

export default SettingsMenu;
